import { attachPageComponent } from '../../../route-utils';
import * as routes from './routes';

const { page, ...actionRoutes } = attachPageComponent(routes, import('./LeadTime'));

export default page;
export { actionRoutes };
